import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnStyledImage from "./image";

const Wrapper = styled.div.attrs(({ $align, $height }) => ({
  $align: $align,
  $height: $height || "500px",
}))`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: ${({ $align }) =>
    $align === "full" ? "1920px" : $align === "wide" ? "1180px" : "500px"};
  height: ${({ $height }) => `${$height}px`};
  margin: 0 auto;
`;

const Overlay = styled.div.attrs(({ $dimRatio, $backgroundColor }) => ({
  $opacity: $dimRatio ? $dimRatio / 100 : 0,
  $backgroundColor: $backgroundColor || "#000",
}))`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ $backgroundColor }) =>
    `var(--color-${$backgroundColor}, var(--color-black))`};
  opacity: ${({ $opacity }) => $opacity};
`;
const Image = styled(UnStyledImage).attrs(({ $height }) => ({
  $height: $height || "500px",
}))`
  width: 100%;
  max-width: 1920px;
  height: ${({ $height }) => $height};
  position: absolute;
  top: 0;
  left: 0;
`;

const InnerBlock = styled.div.attrs(({ $height, $contentPosition }) => ({
  $height: $height || "500px",
  $contentPosition: $contentPosition || "center",
}))`
  position: relative;
  z-index: 5;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: ${({ $contentPosition }) => $contentPosition};
  flex-basis: ${({ $height }) => `${$height}px`};
  flex-grow: 1;
  flex-shrink: 1;
  height: ${({ $height }) => `${$height}px`};
  padding: 20px;
`;
const Name = styled.h2`
  color: currentColor;
  font-weight: 600;
`;
const Description = styled.div.attrs(({ $contentPosition }) => ({
  $contentPosition: $contentPosition || "center",
}))`
  text-align: ${({ $contentPosition }) => $contentPosition};
  color: currentColor;
  max-width: 400px;
`;
const PriceBox = styled.div`
  display: flex;
  margin-inline: auto;
`;
const Price = styled.p`
  color: currentColor;
  margin: 0 0 0 10px;
  font-weight: 600;
`;
const Children = styled.div`
  margin: 20px auto;
`;
const FeaturedProduct = ({
  align,
  className,
  height,
  contentAlign,
  dimRatio,
  overlayColor,
  showPrice,
  showDesc,
  children,
  product,
  media,
}) => {
  return (
    <Wrapper $height={height} $align={align} className={className}>
      <Image
        image={media || product?.image}
        objectPosition={media?.focalPoint?.objectPosition}
      />
      <Overlay $backgroundColor={overlayColor} $dimRatio={dimRatio} />
      <InnerBlock $height={height} $contentPosition={contentAlign}>
        <Name>{product?.name}</Name>
        {showDesc === true ? (
          <Description
            $contentPosition={contentAlign}
            dangerouslySetInnerHTML={{ __html: product?.description }}
          />
        ) : null}
        {showPrice === true ? (
          <PriceBox>
            {product?.regularPrice ? (
              <strike>{product?.regularPrice}</strike>
            ) : null}
            <Price>{product?.price}</Price>
          </PriceBox>
        ) : null}
        <Children>{children}</Children>
      </InnerBlock>
    </Wrapper>
  );
};

FeaturedProduct.propTypes = {
  height: PropTypes.number,
  align: PropTypes.string,
  contentAlign: PropTypes.string,
  className: PropTypes.string,
  overlayColor: PropTypes.string,
  dimRatio: PropTypes.number,
  media: PropTypes.object,
  children: PropTypes.node,
  showDesc: PropTypes.bool,
  showPrice: PropTypes.bool,
  product: PropTypes.shape({
    price: PropTypes.string,
    regularPrice: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.object,
  }),
};

export default FeaturedProduct;
